import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";

import axios from 'axios';
import { API_ROOT } from 'api-config';
import { getApiHeaders } from '../../assets/helpers/apiHelper.jsx';

class PmsAccount extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    this.updatePmsAccount = this.updatePmsAccount.bind(this);
    this.state = {
      userId: props.userId,
      pmsType: '',
      pmsId: '',
      organizationId: props.organizationId,
      updatePmsAccountButtonText: 'update',
      customInputStyle: props.customInputStyle
    };
  }

  componentDidMount(){
    this._isMounted = true;
    this.getPmsAccount()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  getPmsAccount() {
    axios.get(`${API_ROOT}/pmsAccount/?userId=` + this.state.userId + `&organizationId=` + this.state.organizationId, { headers: getApiHeaders() })
      .then(res => this.setPmsAccount(res.data));
  }
  setPmsAccount(res) {
    if (this._isMounted && 'pmsId' in res) {
      this.setState({
        pmsType: res.type,
        pmsId: res.pmsId
      });
    }
  }
  updatePmsAccount = (e) => {
    e.preventDefault();
    const pmsData = {
      userId: this.state.userId,
      organizationId: this.state.organizationId,
      pmsId: this.state.pmsId
    }
    axios.post(`${API_ROOT}/pmsAccount/`, pmsData, {headers: getApiHeaders()})
      .then(res => this.handleUpdateResponse(res));
    this.setState({
      updatePmsAccountButtonText: 'updating...'
    });
  }

  handleUpdateResponse(res) {
    if (this._isMounted) {
      this.setState({
        updatePmsAccountButtonText: 'update'
      });
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            PMS: {this.state.pmsType}
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <CustomInput
              labelText="ID"
              type="text"
              id="pmsId"
              formControlProps={{
                fullWidth: true,
                margin: 'none'
              }}
              inputProps={{
                onChange: this.handleChange,
                value: this.state.pmsId,
                disabled: this.state.inputDisabled
              }}
              customStyle={this.state.customInputStyle}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <Button
              className={classes.updateProfileButton}
              onClick={this.updatePmsAccount}
              color="cirrusBlue"
              disabled={this.state.inputDisabled}
              id="searchPmsButton"
            >
              {this.state.updatePmsAccountButtonText}
            </Button>
          </GridItem>
        </GridContainer>
      </div>
    )

  }


}

export default withStyles(userProfileStyles)(PmsAccount);